import { render, staticRenderFns } from "./RegisterPass.vue?vue&type=template&id=1716c7c5&scoped=true&"
import script from "./RegisterPass.vue?vue&type=script&lang=js&"
export * from "./RegisterPass.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPass.vue?vue&type=style&index=0&id=1716c7c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1716c7c5",
  null
  
)

export default component.exports